export const SET_INVESTMENT = 'SET_INVESTMENT';
export const SET_OPTION_SELECTED = 'SET_OPTION_SELECTED';
